import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-none"
}
const _hoisted_2 = { class: "my-4" }
const _hoisted_3 = { class: "d-flex align-items-center" }
const _hoisted_4 = { class: "mb-0 ml-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputSwitch = _resolveComponent("InputSwitch")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.deviceName)
      ? (_openBlock(), _createBlock("h3", _hoisted_1, _toDisplayString(_ctx.deviceName), 1))
      : _createCommentVNode("", true),
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsGroupZeroCrossing")), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_InputSwitch, {
        modelValue: _ctx.settings.isZeroCrossingEnabled,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.settings.isZeroCrossingEnabled = $event)),
        disabled: _ctx.readonly
      }, null, 8, ["modelValue", "disabled"]),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("AppResource.ActuatorSettingsEnabled")), 1)
    ])
  ]))
}